import { watchRequestReallocateEmissions } from './reallocateEmissions';
export const reallocateEmissionsSaga = [
  watchRequestReallocateEmissions
];
